import { cookieService, publicConfig, urlService } from '../../../services';
import { mainPath } from '../../../constants';
import { FiltersSlugEnum } from '../../../catalog';
import {
  CustomersSubscriptionModel,
  CustomersSubscriptions,
  CustomerSubscriptionStatuses,
} from '../customersSubscription';
import { Nullable } from '../../../models';

export const getSubscriptionCoursesHref = () =>
  urlService.getFullUrlFromToPage(
    urlService.updatePathQuery(mainPath.courses, {
      [FiltersSlugEnum.subscription]: 'all',
    }),
    true
  );

export const getBuySubscriptionHref = () =>
  urlService.getFullUrlFromToPage('/kcell-subscription', true);

export const getKCellSupportHref = () =>
  urlService.getFullUrlFromToPage('/kcell-support', true);

export const getCoursesHref = () =>
  urlService.getFullUrlFromToPage(mainPath.courses, true);

export const canShowKcellSubscriptionBanner = (
  subscriptions: Nullable<CustomersSubscriptionModel[]>
): boolean =>
  publicConfig.KCELL_SUBSCRIPTION_ENABLED === 'true' &&
  !!subscriptions &&
  subscriptions.some(
    ({ subscriptionTemplate }) =>
      subscriptionTemplate.type === CustomersSubscriptions.kcell
  );

const ACTIVATE_SUBSCRIPTION_POPUP_COOKIE = 'kcellSubscription';
const ACTIVATE_SUBSCRIPTION_POPUP_COOKIE_VALUE = 'true';

export const shouldShowActivateSubscriptionPopup = () =>
  cookieService.getCookie(ACTIVATE_SUBSCRIPTION_POPUP_COOKIE) !==
  ACTIVATE_SUBSCRIPTION_POPUP_COOKIE_VALUE;

export const setActivateSubscriptionPopupShown = () => {
  cookieService.setCookie({
    name: ACTIVATE_SUBSCRIPTION_POPUP_COOKIE,
    val: ACTIVATE_SUBSCRIPTION_POPUP_COOKIE_VALUE,
    days: 365,
  });
};

export const getInitialStatusState = (
  subscriptions: Nullable<CustomersSubscriptionModel[]>
): CustomerSubscriptionStatuses =>
  shouldShowActivateSubscriptionPopup() &&
  canShowKcellSubscriptionBanner(subscriptions)
    ? CustomerSubscriptionStatuses.activate
    : CustomerSubscriptionStatuses.loading;

export const getInitialPopupState = (
  subscriptions: Nullable<CustomersSubscriptionModel[]>
): boolean =>
  shouldShowActivateSubscriptionPopup() &&
  canShowKcellSubscriptionBanner(subscriptions);
